/**
 * Every URL segment in the app, declared exactly once.
 *
 * This is the single source of truth for the individual path pieces.
 * `paths.ts`, the route patterns, and the sidebar nav all compose their URLs
 * from these strings, so renaming a segment only ever means editing it here.
 */
export const segments = {
  // top-level sections
  pitches: 'pitches',
  hitterLibrary: 'hitter-library',
  videoLibrary: 'video-library',
  analytics: 'analytics',
  admin: 'admin-portal',
  platformConsole: 'platform-console',
  featureDemo: 'feature-demo',

  // login
  auth0: 'auth0',
  legacy: 'legacy',

  // /pitches/*
  lists: 'lists',
  library: 'library',
  design: 'design',
  upload: 'upload',
  gameData: 'game-data',
  list: 'list',

  // /pitches/game-data/*
  pitchers: 'pitchers',
  games: 'games',

  // /hitter-library/*
  hitters: 'hitters', // also used by /pitches/game-data/hitters
  hitterProfile: 'hitter-profile',
  hitterSession: 'hitter-session', // also used by analytics

  // /analytics/*
  hittingReports: 'hitting-reports',
  sessionHistory: 'session-history',

  // /admin-portal/*
  users: 'users',
  machines: 'machines',
  organizations: 'organizations',
  ballTypes: 'ball-types',
  machineModels: 'machine-models',
  errorTypes: 'error-types',
  staticVideos: 'static-videos',
  apiKeys: 'api-keys',
  serverErrors: 'server-errors',
  serverControls: 'server-controls',

  // /platform-console/*
  featureFlags: 'feature-flags',
  jobs: 'jobs',
  new: 'new',

  // base / pseudo sections (no subsections)
  gameInProgress: 'game-in-progress',
  unavailable: 'unavailable',
  notFound: 'not-found',
} as const;
